import PropTypes from 'prop-types';

const PinIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.095.81a.807.807 0 0 1 .232.561c0 2.851-1.164 5.43-3.031 7.297-.147.147-.305.283-.458.424l5.586 19.455a2.477 2.477 0 0 1-.64 2.45 2.459 2.459 0 0 1-1.747.717l-5.878.005-3.38 14.617a.79.79 0 0 1-.216.385.787.787 0 0 1-.56.232.81.81 0 0 1-.786-.617l-3.379-14.612-5.877-.006a2.476 2.476 0 0 1-1.98-.996 2.429 2.429 0 0 1-.402-2.178l5.57-19.453c-.154-.142-.306-.272-.459-.425a10.254 10.254 0 0 1-3.022-7.298.814.814 0 0 1 .81-.797L33.53.573c.214 0 .412.085.565.238z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

PinIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

PinIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default PinIcon;
